/* /p/<token> is the rack-photo link sent to the WhatsApp group. It opens for people
   with no dashboard login, so the app decides it before the auth gate (App.js) and
   skips the session check entirely (AuthContext) - a stranger's phone should not wait
   on an /auth/me round trip to us-east-1 just to be told "not logged in". */
const m = window.location.pathname.match(/^\/p\/([A-Za-z0-9_-]{10,})\/?$/);
export const SHARE_TOKEN = m ? m[1] : null;
